import { NotepadTextIcon } from 'lucide-react';

export const NoteIcon = NotepadTextIcon;
export default NoteIcon;
